module.exports = __webpack_public_path__ + "static/media/fiction.647c3cda.png";